import { KioskBoardBaseItem } from './KioskBoardBaseItem';
import { KioskBoardItemAddCard } from './KioskBoardItemAddCard';

export const KioskBoardItem = {
	AddCard: KioskBoardItemAddCard,
	Base: KioskBoardBaseItem,
};
